export default {
  globalEventFilter: {},
  globalAllEventFilter: {},
  globalYearFilter: {},
  globalSelectedEvent: {},

  searchStartTime: 'notSet',
  searchEndTime: 'notSet',
  searchStallholders: 'notSet',
  searchStalls: 'notSet',
  searchTerminals: 'notSet',
  deviceId: '',
  stan: '',
  totalAmount: null,
  transactionId: '',

  filterStallHolders: "all",
  // filterStalls: "all",
  // filterTerminals: "all",
  // filterTerminalUsers: "all",
  filterYear: "",

  allYears: [],
  allEvents: [],
  // allFetchedEvents:[],
  // allTotalEvents: [],
  // EOD: {},
  IsAdmin: false,
  // User's event/stallholder/stall permissions from /logon (DynamoDB user record)
  userEventPermissions: [],
  allStallHolders: [],
  allStallTags: [],
  allVouchers: [],
  allTerminalUsers: [],
  allStalls: [],
  // allTerminals: []

}